import React, { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import Avatar from "@mui/material/Avatar";
import { isFullAccess } from "../../../../auth/ProtectedRoutes";
import useAuth from "../../../../hooks/useAuth";
import { getDepartmentDetail } from "../../../../apis/System/department.api";

const departmentRoleStyle = {
  margin: "40px",
};

const departmentEmployeeStyle = {
  margin: "40px",
};

const listEmployeeItem = (employee) => (
  <div key={employee.id}>
    <ListItem alignItems="flex-start">
      <ListItemAvatar>
        <Avatar alt="Remy Sharp" src="/static/images/avatar/1.jpg" />
      </ListItemAvatar>
      <ListItemText
        primary={employee.fullName}
        secondary={
          <React.Fragment>
            <Typography
              sx={{ display: "inline" }}
              component="span"
              variant="body2"
              color="var(--txt-color)"
            >
              Email:
            </Typography>
            <span style={{ color: "var(--txt-color)", marginLeft: "5px" }}>
              {employee.email}
            </span>
          </React.Fragment>
        }
      />
    </ListItem>
    <Divider
      style={{ borderColor: "var(--txt-color)" }}
      variant="inset"
      component="li"
    />
  </div>
);

const listEmployee = (employees) => (
  <List
    sx={{
      width: "100%",
      maxWidth: 360,
    }}
  >
    {employees.map((employee) => listEmployeeItem(employee))}
  </List>
);

const isAccessDepartment = (
  departmentId,
  employeeDepartmentId,
  employeeRoleId
) => {
  return departmentId === employeeDepartmentId || isFullAccess(employeeRoleId);
};

function DepartmentDetail() {
  const { id } = useParams();
  const [departmentDetail, setDepartmentDetail] = useState({});
  const { auth } = useAuth();
  useEffect(() => {
    getDepartmentDetail(id, (result) => {
      setDepartmentDetail(result);
    });
  }, [id]);

  if (auth?.id && isAccessDepartment(id, auth.departmentId, auth?.roles)) {
    return (
      <div>
        <h1>{departmentDetail.name}</h1>
        <span>** {departmentDetail.description}</span>

        <div style={departmentRoleStyle}>
          <h3>Department roles: {departmentDetail?.role?.name}</h3>
        </div>

        <div style={departmentEmployeeStyle}>
          <Accordion
            sx={{
              color: "var(--txt-color)",
              backgroundColor: "var(--main-bg)",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>
                Department employees: {departmentDetail.employees?.length}{" "}
                members
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              {departmentDetail?.employees
                ? listEmployee(departmentDetail?.employees)
                : null}
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    );
  } else {
    return <Redirect to="/" />;
  }
}

export default DepartmentDetail;
